export default [
  {
    inputs: [
      { internalType: "address", name: "_admin", type: "address" },
      { internalType: "uint256", name: "_buffer", type: "uint256" },
      { internalType: "address", name: "_tokenManager", type: "address" },
      { internalType: "address", name: "_mintReceiver", type: "address" },
      { internalType: "address", name: "_glpManager", type: "address" },
      { internalType: "address", name: "_rewardRouter", type: "address" },
      { internalType: "uint256", name: "_maxTokenSupply", type: "uint256" },
      { internalType: "uint256", name: "_marginFeeBasisPoints", type: "uint256" },
      { internalType: "uint256", name: "_maxMarginFeeBasisPoints", type: "uint256" },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: "bytes32", name: "action", type: "bytes32" }],
    name: "ClearAction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "token", type: "address" },
      { indexed: false, internalType: "address", name: "spender", type: "address" },
      { indexed: false, internalType: "uint256", name: "amount", type: "uint256" },
      { indexed: false, internalType: "bytes32", name: "action", type: "bytes32" },
    ],
    name: "SignalApprove",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "token", type: "address" },
      { indexed: false, internalType: "address", name: "receiver", type: "address" },
      { indexed: false, internalType: "uint256", name: "amount", type: "uint256" },
      { indexed: false, internalType: "bytes32", name: "action", type: "bytes32" },
    ],
    name: "SignalMint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: "bytes32", name: "action", type: "bytes32" }],
    name: "SignalPendingAction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "vault", type: "address" },
      { indexed: false, internalType: "address", name: "token", type: "address" },
      { indexed: false, internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "SignalRedeemUsdg",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "target", type: "address" },
      { indexed: false, internalType: "address", name: "gov", type: "address" },
      { indexed: false, internalType: "bytes32", name: "action", type: "bytes32" },
    ],
    name: "SignalSetGov",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "target", type: "address" },
      { indexed: false, internalType: "address", name: "handler", type: "address" },
      { indexed: false, internalType: "bool", name: "isActive", type: "bool" },
      { indexed: false, internalType: "bytes32", name: "action", type: "bytes32" },
    ],
    name: "SignalSetHandler",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "vault", type: "address" },
      { indexed: false, internalType: "address", name: "priceFeed", type: "address" },
      { indexed: false, internalType: "bytes32", name: "action", type: "bytes32" },
    ],
    name: "SignalSetPriceFeed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "vault", type: "address" },
      { indexed: false, internalType: "address", name: "token", type: "address" },
      { indexed: false, internalType: "uint256", name: "tokenDecimals", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "tokenWeight", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "minProfitBps", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "maxUsdgAmount", type: "uint256" },
      { indexed: false, internalType: "bool", name: "isStable", type: "bool" },
      { indexed: false, internalType: "bool", name: "isShortable", type: "bool" },
    ],
    name: "SignalVaultSetTokenConfig",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "target", type: "address" },
      { indexed: false, internalType: "address", name: "token", type: "address" },
      { indexed: false, internalType: "address", name: "receiver", type: "address" },
      { indexed: false, internalType: "uint256", name: "amount", type: "uint256" },
      { indexed: false, internalType: "bytes32", name: "action", type: "bytes32" },
    ],
    name: "SignalWithdrawToken",
    type: "event",
  },
  {
    inputs: [],
    name: "MAX_BUFFER",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_FUNDING_RATE_FACTOR",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_LEVERAGE_VALIDATION",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PRICE_PRECISION",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "admin",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "address", name: "_spender", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vester", type: "address" },
      { internalType: "address[]", name: "_accounts", type: "address[]" },
      { internalType: "uint256[]", name: "_amounts", type: "uint256[]" },
    ],
    name: "batchSetBonusRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "address[]", name: "_tokens", type: "address[]" },
    ],
    name: "batchWithdrawFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "buffer",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "_action", type: "bytes32" }],
    name: "cancelAction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_vault", type: "address" }],
    name: "disableLeverage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_vault", type: "address" }],
    name: "enableLeverage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "glpManager",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_referralStorage", type: "address" },
      { internalType: "bytes32", name: "_code", type: "bytes32" },
      { internalType: "address", name: "_newAccount", type: "address" },
    ],
    name: "govSetCodeOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  { inputs: [], name: "initGlpManager", outputs: [], stateMutability: "nonpayable", type: "function" },
  { inputs: [], name: "initRewardRouter", outputs: [], stateMutability: "nonpayable", type: "function" },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "isHandler",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "isKeeper",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "marginFeeBasisPoints",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxMarginFeeBasisPoints",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxTokenSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintReceiver",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    name: "pendingActions",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "address", name: "_receiver", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" },
    ],
    name: "processMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" },
    ],
    name: "redeemUsdg",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "address", name: "_account", type: "address" },
    ],
    name: "removeAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardRouter",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_admin", type: "address" }],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_buffer", type: "uint256" }],
    name: "setBuffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_handler", type: "address" },
      { internalType: "bool", name: "_isActive", type: "bool" },
    ],
    name: "setContractHandler",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_target", type: "address" },
      { internalType: "address", name: "_admin", type: "address" },
    ],
    name: "setExternalAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "uint256", name: "_taxBasisPoints", type: "uint256" },
      { internalType: "uint256", name: "_stableTaxBasisPoints", type: "uint256" },
      { internalType: "uint256", name: "_mintBurnFeeBasisPoints", type: "uint256" },
      { internalType: "uint256", name: "_swapFeeBasisPoints", type: "uint256" },
      { internalType: "uint256", name: "_stableSwapFeeBasisPoints", type: "uint256" },
      { internalType: "uint256", name: "_marginFeeBasisPoints", type: "uint256" },
      { internalType: "uint256", name: "_liquidationFeeUsd", type: "uint256" },
      { internalType: "uint256", name: "_minProfitTime", type: "uint256" },
      { internalType: "bool", name: "_hasDynamicFees", type: "bool" },
    ],
    name: "setFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "uint256", name: "_fundingInterval", type: "uint256" },
      { internalType: "uint256", name: "_fundingRateFactor", type: "uint256" },
      { internalType: "uint256", name: "_stableFundingRateFactor", type: "uint256" },
    ],
    name: "setFundingRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_cooldownDuration", type: "uint256" }],
    name: "setGlpCooldownDuration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_target", type: "address" },
      { internalType: "address", name: "_gov", type: "address" },
    ],
    name: "setGov",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_target", type: "address" },
      { internalType: "address", name: "_handler", type: "address" },
      { internalType: "bool", name: "_isActive", type: "bool" },
    ],
    name: "setHandler",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "bool", name: "_inPrivateLiquidationMode", type: "bool" },
    ],
    name: "setInPrivateLiquidationMode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "bool", name: "_inPrivateTransferMode", type: "bool" },
    ],
    name: "setInPrivateTransferMode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "bool", name: "_isLeverageEnabled", type: "bool" },
    ],
    name: "setIsLeverageEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "bool", name: "_isSwapEnabled", type: "bool" },
    ],
    name: "setIsSwapEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_keeper", type: "address" },
      { internalType: "bool", name: "_isActive", type: "bool" },
    ],
    name: "setKeeper",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "address", name: "_liquidator", type: "address" },
      { internalType: "bool", name: "_isActive", type: "bool" },
    ],
    name: "setLiquidator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_marginFeeBasisPoints", type: "uint256" },
      { internalType: "uint256", name: "_maxMarginFeeBasisPoints", type: "uint256" },
    ],
    name: "setMarginFeeBasisPoints",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "uint256", name: "_maxGasPrice", type: "uint256" },
    ],
    name: "setMaxGasPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" },
    ],
    name: "setMaxGlobalShortSize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "uint256", name: "_maxLeverage", type: "uint256" },
    ],
    name: "setMaxLeverage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "address", name: "_priceFeed", type: "address" },
    ],
    name: "setPriceFeed",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_referralStorage", type: "address" },
      { internalType: "address", name: "_referrer", type: "address" },
      { internalType: "uint256", name: "_tierId", type: "uint256" },
    ],
    name: "setReferrerTier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_shortsTrackerAveragePriceWeight", type: "uint256" }],
    name: "setShortsTrackerAveragePriceWeight",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bool", name: "_shouldToggleIsLeverageEnabled", type: "bool" }],
    name: "setShouldToggleIsLeverageEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "uint256", name: "_taxBasisPoints", type: "uint256" },
      { internalType: "uint256", name: "_stableTaxBasisPoints", type: "uint256" },
      { internalType: "uint256", name: "_mintBurnFeeBasisPoints", type: "uint256" },
      { internalType: "uint256", name: "_swapFeeBasisPoints", type: "uint256" },
      { internalType: "uint256", name: "_stableSwapFeeBasisPoints", type: "uint256" },
    ],
    name: "setSwapFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_referralStorage", type: "address" },
      { internalType: "uint256", name: "_tierId", type: "uint256" },
      { internalType: "uint256", name: "_totalRebate", type: "uint256" },
      { internalType: "uint256", name: "_discountShare", type: "uint256" },
    ],
    name: "setTier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "uint256", name: "_tokenWeight", type: "uint256" },
      { internalType: "uint256", name: "_minProfitBps", type: "uint256" },
      { internalType: "uint256", name: "_maxUsdgAmount", type: "uint256" },
      { internalType: "uint256", name: "_bufferAmount", type: "uint256" },
      { internalType: "uint256", name: "_usdgAmount", type: "uint256" },
    ],
    name: "setTokenConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "address[]", name: "_tokens", type: "address[]" },
      { internalType: "uint256[]", name: "_usdgAmounts", type: "uint256[]" },
    ],
    name: "setUsdgAmounts",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "contract IVaultUtils", name: "_vaultUtils", type: "address" },
    ],
    name: "setVaultUtils",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "shouldToggleIsLeverageEnabled",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "address", name: "_spender", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" },
    ],
    name: "signalApprove",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "address", name: "_receiver", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" },
    ],
    name: "signalMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" },
    ],
    name: "signalRedeemUsdg",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_target", type: "address" },
      { internalType: "address", name: "_gov", type: "address" },
    ],
    name: "signalSetGov",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_target", type: "address" },
      { internalType: "address", name: "_handler", type: "address" },
      { internalType: "bool", name: "_isActive", type: "bool" },
    ],
    name: "signalSetHandler",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "address", name: "_priceFeed", type: "address" },
    ],
    name: "signalSetPriceFeed",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "uint256", name: "_tokenDecimals", type: "uint256" },
      { internalType: "uint256", name: "_tokenWeight", type: "uint256" },
      { internalType: "uint256", name: "_minProfitBps", type: "uint256" },
      { internalType: "uint256", name: "_maxUsdgAmount", type: "uint256" },
      { internalType: "bool", name: "_isStable", type: "bool" },
      { internalType: "bool", name: "_isShortable", type: "bool" },
    ],
    name: "signalVaultSetTokenConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_target", type: "address" },
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "address", name: "_receiver", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" },
    ],
    name: "signalWithdrawToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenManager",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_sender", type: "address" },
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" },
    ],
    name: "transferIn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "usdgAmount", type: "uint256" }],
    name: "updateUsdgSupply",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "uint256", name: "_tokenDecimals", type: "uint256" },
      { internalType: "uint256", name: "_tokenWeight", type: "uint256" },
      { internalType: "uint256", name: "_minProfitBps", type: "uint256" },
      { internalType: "uint256", name: "_maxUsdgAmount", type: "uint256" },
      { internalType: "bool", name: "_isStable", type: "bool" },
      { internalType: "bool", name: "_isShortable", type: "bool" },
    ],
    name: "vaultSetTokenConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "address", name: "_receiver", type: "address" },
    ],
    name: "withdrawFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_target", type: "address" },
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "address", name: "_receiver", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" },
    ],
    name: "withdrawToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;
